import { render } from "./Banner.vue?vue&type=template&id=904f7ff0"
const script = {}

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__